import { useMemo as t, useCallback as e, createElement as o, Fragment as a } from "react";

const p = ({
  type: t
}) => {
  throw new Error(`Could not find a component mapping for type "${t}"`);
},
      n = n => {
  const {
    getKey: r,
    getType: i,
    list: m = [],
    map: s,
    meta: u,
    mapDataToContext: l,
    mapDataToProps: v,
    default: d = p,
    defaultMapDataToContext: y,
    defaultMapDataToProps: x
  } = n,
        c = t(() => m.map(r), [m, r]),
        C = t(() => m.map(i), [m, i]),
        T = t(() => C.map(t => {
    var e;
    return null !== (e = s[t]) && void 0 !== e ? e : d;
  }), [C, s, d]),
        f = e(t => ({
    list: m,
    keys: c,
    types: C,
    comps: T,
    map: s,
    meta: u,
    index: t,
    data: m[t],
    key: c[t],
    type: C[t],
    Comp: T[t],
    previousData: m[t - 1],
    previousKey: c[t - 1],
    previousType: C[t - 1],
    PreviousComp: T[t - 1],
    nextData: m[t + 1],
    nextKey: c[t + 1],
    nextType: C[t + 1],
    NextComp: T[t + 1]
  }), [T, c, C, u, m, s]),
        D = t(() => m.map((t, e) => {
    var o;
    const a = null !== (o = null == l ? void 0 : l[C[e]]) && void 0 !== o ? o : y;
    return a ? a(f(e)) : void 0;
  }), [f, m, l, C, y]),
        g = e(t => ({ ...f(t),
    contexts: D,
    context: D[t],
    previousContext: D[t - 1],
    nextContext: D[t + 1]
  }), [f, D]),
        k = t(() => m.map((t, e) => {
    var o;
    const a = null !== (o = null == v ? void 0 : v[C[e]]) && void 0 !== o ? o : x;
    return a ? a(g(e)) : void 0;
  }), [g, m, v, C, x]);
  return o(a, null, k.map((t, e) => {
    const a = T[e];
    return o(a, Object.assign({
      key: c[e],
      ...t
    }, a === d ? {
      type: C[e]
    } : void 0));
  }));
};

export { n as MapToComponents };